'use strict';

var processInclude = require('base/util');

$(document).ready(function () {
    processInclude(require('./product/detail'));
    processInclude(require('./product/components/pyPdpCarousel'));
    processInclude(require('./product/components/pyDeliveryCheck'));
});
